import type { FaireProductEntity } from "../../entity_types/product";

export const p_8b59t6hehq: FaireProductEntity = {
  token: "p_8b59t6hehq",
  type: "product",
  name: "Crystal Infused Aromatherapy Organic Body Oil Rollerballs",
  brandToken: "b_d5394221",
  brandName: "Honeybee Gardens Natural Cosmetics & Body Care",
  imageUrl:
    "https://cdn.faire.com/fastly/02ce962188a8a8b2933930b661e4229a76b8d592316142fa00d84a63b8e897d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cffdb50f55fec0aa20d2a65e88ea7653b0587f1e172ef57998fa374203ea7816.jpeg",
    "https://cdn.faire.com/fastly/8570bb2e6716c6ffbeff0ca063886457aaf5a4c193ee5b927c7f1f89c796849b.png",
    "https://cdn.faire.com/fastly/5dc632e66bc48b0c12d56a83fc7a81701594cf730f3a9468b9a218d76b78292c.png",
    "https://cdn.faire.com/fastly/5576af6dbc76a6a07b8fd9d8f1215cdb7c52652d578fb3b4aec795d5e521f84e.png",
    "https://cdn.faire.com/fastly/00abd792588e7a97677f7d7d1a9bae020f8a3bff30f7705621fc01d26187827a.png",
    "https://cdn.faire.com/fastly/3e6883cedb0571d1fa27d13ff86a302f6a3ba61aae1798be2a0a0c2f426b7bbb.png",
    "https://cdn.faire.com/fastly/c057c1f672ab6abb16e9dcb3656ef416dd46e4e1620b8e975ef8d50529e574fa.png",
    "https://cdn.faire.com/fastly/71ecf4ab0a545f3ee67268c934889a30a12ef5ca5fb3d03b00d1fa18518321f5.png",
    "https://cdn.faire.com/fastly/d1e927e075ae42be0c6134b9ab3dead6b9dae85a6b9828de09fa559d6a657a90.png",
    "https://cdn.faire.com/fastly/94fc558d65fa7e9f83fb59a29fd81843600c1b9731777bc784b40cf54fcbbc94.png",
    "https://cdn.faire.com/fastly/eb790654936659f0dbf03ad7030764cca12233bb741cadd4ebf4d395a59cdd12.png",
    "https://cdn.faire.com/fastly/d8a123cec0b7b63463bb5ec52fa38b212bffff57ee3c35d2e4b84f8f8c00a227.png",
    "https://cdn.faire.com/fastly/70509a601af4ca531b1f8759316f4a028bb7c5071a93c35960fe9d129a235d9f.png",
    "https://cdn.faire.com/fastly/17032638983a813de7fb2bec8099829c359889f303359ad2830cd5bfabaceada.png",
    "https://cdn.faire.com/fastly/41c7846b355155f8f328385d0a0a5d9e50289ffee2ce1a1f0ff752e786609c59.png",
    "https://cdn.faire.com/fastly/c98b9b186be3cb1d193e48a0499a9383d67648601e97b27d9df7b20b901b98f3.png",
  ],
  priceDollars: 5.79,
  description:
    "These adorable rollerballs are perfect as on the go stress tamers! The roller ball applicators are genuine stone for ultimate grounding and healing. \n\nORGANIC, skin-soothing oils infused with real gemstones & positive healing energy is enhanced by an aroma-therapeutic blend of essential oils. Use as a body oil, meditation oil, massage oil, bath oil, or fragrance oil. \n\nOur Crystal Infused Oils make beautiful stocking stuffers, holiday presents, Christmas gifts, teacher gifts, etc. ",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:42.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
